module.exports = __webpack_public_path__ + "media/images/crosswords/p1-29e5feb1d44f41e55e8ad0263e17edf3.png";